import moment, {utc} from "moment";
import "moment-timezone";
import timeZone from "moment-timezone/data/meta/latest.json";
import {
  TIME_FORMAT,
  DATE_FORMAT,
  CALENDAR_DATE_FORMAT,
} from "../../../constants";

let appTimeZone = undefined;

const _getCountryTimeZone = (countryCode) => {
  return (
    timeZone.countries[countryCode] && timeZone.countries[countryCode].zones[0]
  );
};

const _getUserTimeZone = () => {
  return moment.tz.guess();
};

export const setTimeZone = (countryCode) => {
  if (countryCode) appTimeZone = _getCountryTimeZone(countryCode);
  else appTimeZone = _getUserTimeZone();
};

export const convertTimeZone = function (
  dateTimeInUTC,
  returnFormat = "DD/MM/YYYY hh:mm A",
  zone = appTimeZone
) {
  const inputFormat = "YYYY/MM/DD HH:mm:ss ZZ";
  const estDateTime = utc(dateTimeInUTC, inputFormat).tz(zone);
  return estDateTime.format(returnFormat);
};

export const formatUTCTime = (dateObj, zone) =>
  convertTimeZone(dateObj, TIME_FORMAT, zone);

export const formatUTCDate = (dateObj, zone) =>
  convertTimeZone(dateObj, DATE_FORMAT, zone);

export const getInternationalDate = (dateObj, zone) => {
  const dateArr = formatUTCDate(dateObj, zone).split(", ");
  return {date: dateArr[0], day: dateArr[1].toLowerCase()};
};

export const getCalendarDate = (dateObj) =>
  moment(dateObj).format(CALENDAR_DATE_FORMAT);

export const getTime = (dateObj) => moment(dateObj).local();

export const dateInReqFormat = (date, format, locale = "es") => {
  moment.locale(locale);
  const inputFormat = "YYYY-MM-DD";
  const formattedDate = utc(date, inputFormat);
  return formattedDate.format(format);
};

export const showTimeRange = (start, end, timezone) => {
  const inputFormat = "HH:mm";
  const startTime = utc(start).tz(timezone);
  const endTime = end !== "" ? utc(end).tz(timezone) : "";
  const formattedStartTime = startTime.format(inputFormat);
  const formattedEndTime = end !== "" ? `a ${endTime.format(inputFormat)}` : "";
  return `${formattedStartTime} ${formattedEndTime}`;
};
